'use client';

import Link from 'next/link';
import React from 'react';
import { ApiRoutes, Routes } from '@/settings/routes';

export default function RecentTravelGuide({ data }) {
    if (!data) return null;
    const img = data?.miniature ? ApiRoutes.ASSETS_ENDPOINT + data.miniature : 'https://placehold.co/160x120';

    return (
        <Link prefetch={false} href={Routes.FRONT_travel_guide + data.slug} className="flex gap-3 items-center group">
            <div className="w-20 h-14 overflow-hidden rounded bg-gray-100 shrink-0">
                <img src={img} alt={data?.title || 'Travel guide'} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="flex flex-col gap-1">
                <span className="text-sm font-semibold text-custom-color-headline line-clamp-2 group-hover:text-custom-orange-900 transition-colors">{data?.title}</span>
            </div>
        </Link>
    );
}

